<template>
    <div class="empty nibnut-offline">
        <div class="empty-icon">
            <mountain-icon size="5x" />
        </div>
        <p class="empty-title h5">{{ translate("Off the beaten path, are we?") }}</p>
        <p class="empty-subtitle">{{ translate("You are currently offline - good for you! Your app will be right back as soon as it can grab a network...") }}</p>
    </div>
</template>

<script>
import MountainIcon from "@/nibnut/icons/MountainIcon"

export default {
    name: "Offline",
    components: {
        MountainIcon
    }
}
</script>

<style lang="scss">
@import "@/assets/sass/variables";

.nibnut-offline {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: $zindex-offline;
}
</style>
